import React, { useState, useEffect } from "react";
import { makeStyles } from "@mui/styles";
//*MUI
import { Box, Modal } from "@mui/material";
//*files
import cssClasses from "./ChangeToken.module.css";
import Close from "../../Components/Icons/Close";
//subComponent
import CustomInput from "../../Subcomponents/CustomInput";
import Button from "../../Subcomponents/Button";
import DateComponent from "../../Subcomponents/DateComponent";
import DropDown from "../../Subcomponents/DropDown";
import CustomRadio from "../../Subcomponents/CustomRadio";
import RupeeIcon from "../../Assets/Images/Sustenance/RupeeIcon.svg";
import PinIcon from "../../Assets/Images/Sustenance/pinIcon.svg";
import { Card } from "@mui/material";
//
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";

import { useSelector } from "react-redux";
//service
import {
  getEventToken,
  getAllEvents,
  getSelectedToken,
  getAllTokens,
  updateEventLeadToken,
  getAllFutureEvents,
  updateEventLeadTokenSpecific,
  updateLeadStatus,
  checkForPerquisiteToken,
} from "../../Services/AssignNewToken";
import { errorTost, offlineToast, successTost } from "../../Services/Toast";
import { dismissLoader, presentLoader } from "../../Services/loader";
import { createPaymentLink } from "../../Services/PaymentApi";
import { Network } from "@capacitor/network";
import { useNavigate } from "react-router-dom";
import LeadStatusChip from "../../Subcomponents/LeadStatusChip";
import Dot from "../../Components/Icons/Dot";
import { addLeadLogs } from "../../Services/Lead";

const useStyles = makeStyles((theme) => ({
  wrapperIcons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "space-around",
    marginBottom: "2rem",
    position: "relative",
  },
  closeIcon: {
    cursor: "pointer",
    position: "absolute",
    right: "1.7rem",
    top: "1.7rem",
  },
  title: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.8rem",
    lineHeight: "2.8rem",
    color: "#101828",
    marginBottom: "0.8rem",
  },
  subTitle: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    color: "#667085",
    marginBottom: "3.2rem",
  },
  labelCard: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    color: "#667085",
    marginBottom: "3.2rem",
  },
  labelValue: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    color: "#667085",
    marginBottom: "3.2rem",
  },
  wrapperButtons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    columnGap: "1.2rem",
  },
  backArrow: {
    verticalAlign: "middle",
  },
  tokenName: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "2rem",
    lineHeight: "3rem",
    color: "#000000",
  },
}));

export default function ChangeToken({
  open,
  handleClose,
  returnRes,
  data,
  changeTokenPassData,
}) {
  const classes = useStyles();
  let loggedInUser = {};
  const navigate = useNavigate();
  loggedInUser = useSelector((state) => state.Auth.user);
  console.log(data);
  // **tocheck if this has preRequiste
  const [TokenList, setTokenList] = useState([]);
  const [changeTokenData, setChangeTokenData] = useState({
    event: "",
    currentToken: "",
    currentTokenInfo: null,
    selectedEventToken: null,
    // paymentMethod: "",
    changedEvent: "",
    changedToken: "",
    changedTokenInfo: "",
    tokenNumber: "",
  });
  const [helperText, setHelperText] = useState({
    event: "",
    currentToken: "",
    // paymentMethod: "",
    // upiUrl: "",
  });
  const [EventList, setEventList] = useState([]);
  const [tokenInfo, setTokenInfo] = useState([]);
  const [showNoTokens, setShowNoTokens] = useState(false);
  const [tokenCount, setTokenCount] = useState(0);
  const [nextCount, setNextCount] = useState(0);
  const [oldEventTokenData, setOldEventTokenData] = useState("");
  const [prereqErrMsg, setPrereqErrMsg] = useState('');
  useEffect(() => {
    setPrereqErrMsg('');
    console.log("---->", { changeTokenPassData });
    setOldEventTokenData(changeTokenPassData);
    setChangeTokenData((pre) => {
      pre.event = changeTokenPassData.eventName;
      pre.currentToken = changeTokenPassData.tokenName;
      return pre;
    });
    getTokenDetails(changeTokenPassData.eventId.eventId);
    // getAllTokensFun(
    //   changeTokenPassData.eventId.eventId,
    //   changeTokenPassData.tokenName
    // );
  }, []);
  useEffect(() => {
    getAllFutureEvents()
      .then((resp) => {
        console.log(resp);
        let newArr = [];
        // resp.data=resp.data.filter(({allowTokenBuyingInEvent})=>allowTokenBuyingInEvent===true)
        resp.data.forEach((el) => {
          // ??live event
          if (el.startDateTime < Date.now() && el.endDateTime > Date.now()) {
            if (el.allowTokenBuyingInEvent) {
              newArr.push(el);
            }
          }
          // ??Upcoming event
          else if (
            el.startDateTime > Date.now() &&
            el.endDateTime > Date.now()
          ) {
            newArr.push(el);
          }
        });
        console.log("getAllFutureEvents", newArr)
        setEventList([...newArr]);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  //get current token lead has with that specific event
  function getTokenDetails(eventId) {
    getSelectedToken(data.leadId, eventId)
      .then((resp) => {
        console.log("toCheckPrequiste", { resp });
        resp = resp.data.map((eachToken, index) => ({
          ...eachToken,
          index: index,
          eventPreRequisteCheck: eachToken?.eventTokenId?.eventTokenId,
          isSelected: false,
          name: eachToken.eventTokenId?.tokenId?.name,
        }));
        console.log("selected Token", resp);
        setTokenList([...resp]);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  //get All token except current one that lead already has.
  function getAllTokensFun(eventId, tokenName) {
    Network.getStatus().then((status) => {
      if (status.connected) {
        getAllTokens(tokenName, eventId)
          .then((resp) => {
            console.log("resp before filter", resp.length)
            console.log("changeTokenPassData", changeTokenPassData)
            resp = resp.filter(({ tokenId }) => tokenId !== null && (!tokenId.isPreselect && !tokenId.isPriorityPass) || (tokenId.isPreselect));
            console.log("resp after filter", resp);
            resp = resp.filter(f => f.tokenId.tokenId !== changeTokenPassData.eventTokenId.tokenId.tokenId).map((eachToken, index) => ({
              ...eachToken,
              index: index,
              isSelected: false,
            }));

            setTokenInfo(resp);
            console.log("resp!!!", resp)
            console.log({ tokenInfo });
            if (resp.length === 0) {
              setShowNoTokens(true);
            } else {
              resp[0].isSelected = true;
              setShowNoTokens(false);
              setChangeTokenData((pre) => {
                pre.selectedEventToken = resp[0];
                return { ...pre };
              });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        offlineToast();
      }
    });
  }

  // function checkAmountToBePaid() {
  //   console.log(oldEventTokenData);
  //   console.log(changeTokenData.selectedEventToken);
  //   //case 1st when already paid amount is greater than current token amount
  //   //query pending for other way round
  //   if (
  //     oldEventTokenData.amount >
  //     changeTokenData.selectedEventToken.tokenId.amount
  //   ) {
  //     Network.getStatus().then((status) => {
  //       if (status.connected) {
  //     updateEventLeadTokenSpecific(
  //       changeTokenData.selectedEventToken.tokenId.amount,
  //       oldEventTokenData.amount,
  //       changeTokenData.selectedEventToken.eventTokenId,
  //       changeTokenData.selectedEventToken.eventId,
  //       data.leadId,
  //       changeTokenData.selectedEventToken.tokenId.tokenNumber,
  //       changeTokenPassData.paymentId,
  //       changeTokenPassData.status
  //     )
  //       .then((resp) => {
  //         console.log(resp);
  //         let obj = {
  //           leadId: data.leadId,
  //           leadStatus: "Change token completed",
  //           message: `Changed token successfully from token ${changeTokenPassData.tokenName} (${changeTokenPassData.tokenType}) of event to token ${changeTokenData.currentToken} (${changeTokenData.selectedEventToken.tokenId.inventoryTypeId.type}) of event ${changeTokenData.event}`,
  //         };
  //         addLeadLogs(obj)
  //           .then((leadLog) => {
  //             console.log(leadLog);
  //           })
  //           .catch((err) => {
  //             console.log("leadlog", err);
  //           });
  //         successTost(`Changed token successfully from token ${changeTokenPassData.tokenName} (${changeTokenPassData.tokenType}) of event to token ${changeTokenData.currentToken} (${changeTokenData.selectedEventToken.tokenId.inventoryTypeId.type}) of event ${changeTokenData.event}`);
  //         returnRes(true);
  //         closeModal();
  //       })
  //       .catch((err) => {
  //         console.log(err);
  //       });
  //     }else{
  //       offlineToast();
  //     }});
  //   } else {
  //     save();
  //   }
  // }

  function validateFirstNext() {
    var form = true;
    if (changeTokenData.token === "") {
      form = false;
      setHelperText((preValue) => {
        preValue.currentToken = "Please select Event";
        return { ...preValue };
      });
    }
    if (changeTokenData.token !== "") {
      if (changeTokenData.selectedEventToken === null) {
        form = false;
        errorTost("Please Select token");
      }
    }

    return {
      flag: form,
    };
  }
  function checkAllFieldsAreFilled() {
    console.log("->->", { oldEventTokenData }, { changeTokenData });
    let flag = validateFirstNext();

    if (flag.flag) {
      // setDisableNext(false);
      console.log("we are here")
      setNextCount(nextCount + 1);
      // ??update
    } else {
      // setDisableNext(true);
    }
  }
  function closeModal() {
    handleClose();
    setHelperText((pre) => {
      pre.title = "";
      pre.description = "";
      pre.type = "";
      return { ...pre };
    });
  }

  function getTodayDate() {
    var dateObj = new Date();
    var month = (dateObj.getMonth() + 1).toString().padStart(2, "0");
    var day = dateObj.getDate().toString().padStart(2, "0");
    var year = dateObj.getUTCFullYear();
    return year.toString() + month.toString() + day.toString();
  }


  function RouteToPreselect() {
    sessionStorage.setItem("isEventLive", JSON.stringify(true));
    navigate(
      `/home/Event/Details/${changeTokenData?.selectedEventToken?.eventId}/DirectAllotment`
    );
    sessionStorage.setItem(
      "GlobalLeadPreSelected",
      JSON.stringify(true)
    );

    const paymentIdData = changeTokenPassData
    sessionStorage.setItem(
      "GlobalLeadPreSelectedLeadData",
      JSON.stringify({ ...data, ...changeTokenData, paymentIdData })
    );
    dismissLoader();
  }

  function ErrorToastMessages() {
    dismissLoader();
    errorTost(
      `First, buy ${changeTokenData?.selectedEventToken.prerequisiteId.tokenId.name} for ${changeTokenData?.selectedEventToken.tokenId.name}!`
    );
  }

  function UpdateTokenTableAndCreatePaymentLink(tokenNumber) {
   //*Update query to token-leads-leadStatus-leadLogs tables & create payment link
    updateEventLeadTokenSpecific(
      changeTokenData.selectedEventToken.tokenId.amount,
      oldEventTokenData.paidAmount,
      changeTokenData.selectedEventToken.eventTokenId,
      changeTokenData.selectedEventToken.eventId,
      data.leadId,
      tokenNumber,
      changeTokenPassData.paymentId,
      oldEventTokenData.paidAmount === changeTokenData.selectedEventToken.tokenId.amount ? "active" : "partial"
    )
      .then((resp) => {
        console.log(resp);
        let body = {
          leadName: data?.leadname,
          leadEmail: data?.leademail,
          leadContactNumber: data?.leadcontactnumber,
          leadId: data?.leadId,
          eventTokenId: changeTokenData.selectedEventToken.eventTokenId,
          eventName: changeTokenPassData.eventName,
          amount:
            changeTokenData.selectedEventToken.tokenId.amount -
            oldEventTokenData.amount,
          tokenName: changeTokenData.selectedEventToken.tokenId.name,
          paymentId: changeTokenPassData.paymentId,
          mode: "token",
        };
        updateLeadStatus(data.leadId)
          .then((leadStatusResp) => {
            createPaymentLink(body)
              .then((respFromPaymentLink) => {
                console.log(respFromPaymentLink);
                dismissLoader();
                let obj = {
                  leadId: data.leadId,
                  leadStatus: "Change token completed",
                  message: `Changed token successfully from token ${oldEventTokenData.tokenName} (${oldEventTokenData.tokenType}) of event to token ${changeTokenData.selectedEventToken.tokenId.name} (${changeTokenData.selectedEventToken.tokenId.inventoryTypeId.type}) of event ${changeTokenData.changedEvent}`,
                };
                addLeadLogs(obj)
                  .then((leadLog) => {
                    console.log(leadLog);
                  })
                  .catch((err) => {
                    console.log("leadlog", err);
                  });
                successTost(`Changed token successfully from token ${oldEventTokenData.tokenName} (${oldEventTokenData.tokenType}) of event to token ${changeTokenData.selectedEventToken.tokenId.name} (${changeTokenData.selectedEventToken.tokenId.inventoryTypeId.type}) of event ${changeTokenData.changedEvent}`);

                returnRes(true);
                closeModal();
              })
              .catch((err) => {
                console.log(err);
                dismissLoader();
              });
          }).catch((err) => {
            console.log(err);
          })

      })
      .catch((err) => {
        console.log(err);
      });
    closeModal();
  }

  function UpdateTokenTable(tokenNumber) {
    //*Update Tables only
    updateEventLeadTokenSpecific(
      changeTokenData.selectedEventToken.tokenId.amount,
      oldEventTokenData.paidAmount,
      changeTokenData.selectedEventToken.eventTokenId,
      changeTokenData.selectedEventToken.eventId,
      data.leadId,
      tokenNumber,
      changeTokenPassData.paymentId,
      oldEventTokenData.paidAmount === changeTokenData.selectedEventToken.tokenId.amount ? "active" : "partial"
    )
      .then((resp) => {
        console.log(resp);
        let obj = {
          leadId: data.leadId,
          leadStatus: "Change token completed",
          message: `Changed token successfully from token ${oldEventTokenData.tokenName} (${oldEventTokenData.tokenType}) of event to token ${changeTokenData.selectedEventToken.tokenId.name} (${changeTokenData.selectedEventToken.tokenId.inventoryTypeId.type}) of event ${changeTokenData.changedEvent}`,
        };
        addLeadLogs(obj)
          .then((leadLog) => {
            console.log(leadLog);
          })
          .catch((err) => {
            console.log("leadlog", err);
          });
        closeModal();
        dismissLoader()
        successTost(`Changed token successfully from token ${oldEventTokenData.tokenName} (${oldEventTokenData.tokenType}) of event to token ${changeTokenData.selectedEventToken.tokenId.name} (${changeTokenData.selectedEventToken.tokenId.inventoryTypeId.type}) of event ${changeTokenData.changedEvent}`);
        returnRes(true);
      })
      .catch((err) => {
        console.log(err);
      });
      closeModal()
  }

  function save() {
    Network.getStatus().then((status) => {
      if (status.connected) {
        setPrereqErrMsg('');
        console.log(changeTokenData.selectedEventToken.tokenId.shortToken);
        let todaysDate = getTodayDate();
        const tokenNumber =
          changeTokenData.selectedEventToken.tokenId.shortCode +
          "-" +
          todaysDate +
          "-" +
          Math.floor(1000 + Math.random() * 9000);
        // ??never going to get this check
        presentLoader();
        if (
          oldEventTokenData.amount >
          changeTokenData.selectedEventToken.tokenId.amount
        ) {
          // **only update -> old amt = 2000 , new amt = 1000
          closeModal();
          dismissLoader();
        } else if (
          oldEventTokenData.amount <
          changeTokenData.selectedEventToken.tokenId.amount
        ) {
          // **transaction api call only here... -> old = 1000 , new == 2000
          console.log("amount", changeTokenData.selectedEventToken.tokenId.amount -
            oldEventTokenData.amount,)
          if (changeTokenData?.selectedEventToken?.tokenId?.isPreselect) {
            if (changeTokenData?.selectedEventToken?.prerequisiteId !== null) {
              checkForPerquisiteToken(changeTokenData?.selectedEventToken?.prerequisiteId?.eventTokenId, data.leadId).then((eachToken) => {
                console.log("prerequisite", eachToken);
                if (eachToken.length === 0) {
                  ErrorToastMessages()

                } else {
                  // ? vedashree changes
                  // ! for PBC event, if there is prerequisite for Preselect token, then do not allow preselect allotment
                  // ! instead, show error msg that use this prerequisite 1st
                  errorTost(`You already have prerequisite token (${changeTokenData?.selectedEventToken.prerequisiteId.tokenId.name}) for ${changeTokenData?.selectedEventToken.tokenId.name}!`)
                  // setPrereqErrMsg(`You already have prerequisite token (${changeTokenData?.selectedEventToken.prerequisiteId.tokenId.name}) for ${changeTokenData?.selectedEventToken.tokenId.name}!`)
                  // sessionStorage.setItem("isEventLive", JSON.stringify(true));
                  // navigate(
                  //   `/home/Event/Details/${changeTokenData?.selectedEventToken?.eventId}/DirectAllotment`
                  // );
                  // sessionStorage.setItem(
                  //   "GlobalLeadPreSelected",
                  //   JSON.stringify(true)
                  // );
                  // const paymentIdData = changeTokenPassData
                  // sessionStorage.setItem(
                  //   "GlobalLeadPreSelectedLeadData",
                  //   JSON.stringify({ ...data, ...changeTokenData, paymentIdData })
                  // );
                  dismissLoader();
                }
              })
            } else {
              console.log("we are else part of prerequisite , go to preselect")
              RouteToPreselect()
            }
          } else {
            if (changeTokenData?.selectedEventToken?.prerequisiteId !== null) {
              checkForPerquisiteToken(
                changeTokenData?.selectedEventToken.prerequisiteId.eventTokenId,
                data.leadId
              )
                .then((eachToken) => {
                  console.log(eachToken);
                  if (eachToken.length === 0) {
                    ErrorToastMessages()
                  } else {
                    UpdateTokenTableAndCreatePaymentLink(tokenNumber)
                  }
                })
                .catch((err) => {
                  console.log(err);
                });
            } else {
              UpdateTokenTable(tokenNumber)
            }
          }
          //query pending
          closeModal();
        } else {
          //*old amt === new amt
          if (changeTokenData?.selectedEventToken?.tokenId?.isPreselect) {
            //*check for perquisite token
            console.log("we are here for preselect")
            if (changeTokenData?.selectedEventToken?.prerequisiteId !== null) {
              checkForPerquisiteToken(changeTokenData?.selectedEventToken?.prerequisiteId?.eventTokenId, data.leadId).then((eachToken) => {
                console.log("pre-requestidid", eachToken);
                if (eachToken.length === 0) {
                  ErrorToastMessages()
                } else {
                  RouteToPreselect()
                }
              })
            } else {
              console.log("we are else part of prerequisisted , go to preselect")
              RouteToPreselect()
            }
          } else {
            if (changeTokenData?.selectedEventToken?.prerequisiteId !== null) {
              checkForPerquisiteToken(
                changeTokenData?.selectedEventToken.prerequisiteId.eventTokenId,
                data.leadId
              )
                .then((eachToken) => {
                  console.log(eachToken);
                  if (eachToken.length === 0) {
                    ErrorToastMessages()
                  } else {
                    UpdateTokenTable(tokenNumber)
                  }
                })
                .catch((err) => {
                  console.log(err);
                });
            } else {
              UpdateTokenTable(tokenNumber)
            }
          }
        }
      } else {
        offlineToast();
      }
    });
  }

  function numberWithCommas(x) {
    return x?.toString().replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ",");
  }
  return (
    <Modal
      open={open}
      onClose={(_, reason) => {
        if (reason !== "backdropClick") {
          closeModal();
        }
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={[
        {
          ".MuiBackdrop-root": {
            background: "rgba(52, 64, 84, 0.7)",
          },
        },
      ]}
      disableAutoFocus={true}
    >
      <Box className={cssClasses.modalWrapper}>
        <div className={cssClasses.wrapperHeader}>
          <span className={classes.closeIcon} onClick={closeModal} tabIndex={0}>
            <Close width={"1.2rem"} height={"1.2rem"} />
          </span>
          <div>Change Token</div>
        </div>
        <div className={cssClasses.wrapperContent}>
          {nextCount === 0 && (
            <>
              <div className={cssClasses.wrapperSecondBlock}>
                <div className={cssClasses.wrapperBlock}>
                  <div className={cssClasses.blockLabel}>
                    Selected Event <span style={{ color: "red" }}> *</span>
                  </div>
                  <div style={{ width: "100%" }}>
                    <CustomInput
                      placeholder={"Selected Event"}
                      inputType='text'
                      value={changeTokenData.event}
                      disabled={true}
                    // disabled={}

                    />
                  </div>
                </div>
                <div className={cssClasses.wrapperBlock}>
                  <div className={cssClasses.blockLabel}>
                    Selected token:{" "}
                    <span style={{ color: "red" }}> *</span>
                  </div>
                  <div style={{ width: "100%" }}>
                    {/* <DropDown
                    list={TokenList.map((element, id) => {
                      return {
                        label: element.eventTokenId.tokenId.name,
                        value: element.eventTokenId.tokenId.name,
                      };
                    })}
                    disable={true}
                    selectedValue={changeTokenData.currentToken}
                    onChangeSelect={(value) => {
                      setChangeTokenData((pre) => {
                        pre.currentToken = value;
                        return { ...pre };
                      });
                      setHelperText((pre) => {
                        pre.event = "";
                        return { ...pre };
                      });
                      let selectedToken;
                      selectedToken = TokenList.filter(
                        ({ name }) => value === name
                      );
                      console.log(selectedToken);
                      getAllTokensFun(selectedToken[0].eventId);
                      setOldEventTokenData(selectedToken[0]);
                      //   getTokenDetails(selectedEvent[0].eventId);
                      //   typeList.forEach((el, index) => {
                      //     if (el.value === value) {
                      //       setTypeList((pre) => {
                      //         pre[index].isSelected = true;
                      //         return [...pre];
                      //       });
                      //     } else {
                      //       setTypeList((pre) => {
                      //         pre[index].isSelected = false;
                      //         return [...pre];
                      //       });
                      //     }
                      //   });
                    }}
                    placeHolder={"Select"}
                    //style.color is placeHolder's color
                    style={{
                      background: "#F2F4F7",
                      color: "rgb(102, 112, 133)",
                    }}
                    helperText={helperText.event}
                  /> */}
                    <CustomInput
                      placeholder={"Selected Token"}
                      inputType='text'
                      value={changeTokenData.currentToken}
                      disabled={true}
                    // disabled={}

                    />


                  </div>



                </div>
              </div>
              <div className={cssClasses.wrapperSecondBlock}>
                <div className={cssClasses.blockLabel} >
                  Token Amount<span style={{ color: "red" }}> *</span>
                  <div>
                    ₹{numberWithCommas(changeTokenPassData.eventTokenId.tokenId.amount)}
                  </div>

                </div>
                <div className={cssClasses.blockLabel} >
                  Token Type    <span style={{ color: "red" }}> *</span>
                  <div>
                    {changeTokenPassData.tokenType}
                  </div>

                </div>
                <div className={cssClasses.blockLabel} >
                  Paid Token Amount<span style={{ color: "red" }}> *</span>
                  <div>
                    ₹{numberWithCommas(changeTokenPassData.paidAmount)}
                  </div>

                </div>
              </div>
              {EventList.length > 0 ? <div className={cssClasses.wrapperBlock}>
                <div className={cssClasses.blockLabel}>
                  Change Event to:{" "}
                  <span style={{ color: "red" }}> *</span>
                </div>
                <div style={{ width: "100%" }}>
                  <DropDown
                    list={EventList.map((element, id) => {
                      return {
                        label: element.title,
                        value: element.title,
                      };
                    })}
                    selectedValue={changeTokenData.changedEvent}
                    onChangeSelect={(value) => {
                      setTokenInfo([]);
                      setTokenList([]);
                      setChangeTokenData((pre) => {
                        pre.changedEvent = value;
                        pre.changedToken = "";
                        return { ...pre };
                      });

                      // setHelperText((pre) => {
                      //   pre. = "";
                      //   return { ...pre };
                      // });

                      let selectedEvent;
                      selectedEvent = EventList.filter(
                        ({ title }) => value === title
                      );
                      console.log(selectedEvent);
                      // getTokenDetails(selectedEvent[0].eventId);
                      getAllTokensFun(selectedEvent[0].eventId, selectedEvent[0].tokenName)
                    }}
                    placeHolder={"Select"}
                    //style.color is placeHolder's color
                    style={{
                      background: "#F2F4F7",
                      color: "rgb(102, 112, 133)",
                    }}
                    helperText={helperText.event}
                  />
                </div>
              </div> : <div className={cssClasses.tokenTable}>
                <div className={cssClasses.blockLabel} style={{ color: "red", textAlign: "left" }}>
                  No upcoming events to change token.
                </div>
              </div>}

              {tokenInfo.length > 0 && (
                <div className={cssClasses.wrapperTable}>
                  <div className={cssClasses.blockLabel}>
                    Select Token <span style={{ color: "red" }}> *</span>
                  </div>
                  {tokenInfo.map((eachToken, index) => {
                    return (
                      <Card className={cssClasses.tokenCard}>
                        <div>
                          <FormControl>
                            <RadioGroup
                              row
                              aria-labelledby="demo-row-radio-buttons-group-label"
                              name="row-radio-buttons-group"
                              sx={{
                                "& .MuiSvgIcon-root": {
                                  color: "#155EEF !important",
                                  fontSize: "2rem !important",
                                },
                              }}
                              value={eachToken.isSelected}
                              onChange={(e) => {
                                setTokenInfo((pre) => {
                                  pre = pre.map((m) => ({
                                    ...m,
                                    isSelected: false,
                                  }));
                                  console.log(pre);
                                  pre[index].isSelected = true;
                                  return [...pre];
                                });
                                setChangeTokenData((pre) => {
                                  pre.selectedEventToken = eachToken;
                                  return { ...pre };
                                });
                                console.log(tokenInfo);
                              }}
                            >
                              <FormControlLabel
                                className={classes.radioLabel}
                                value={true}
                                control={<Radio />}
                                label={
                                  <div className={classes.radioLabel}></div>
                                }
                              />
                            </RadioGroup>
                          </FormControl>
                        </div>
                        <div className={cssClasses.labelValue}>
                          <div className={cssClasses.wrapperLabelAndValue}>
                            <span
                              className={classes.tokenName}
                              title={eachToken?.tokenId?.name}
                            >
                              {eachToken?.tokenId?.name}
                            </span>
                          </div>
                          <div>
                            <span className={classes.labelValue}>
                              {eachToken?.tokenId?.inventoryTypeId?.type}
                            </span>
                          </div>
                          <div>
                            {/* <span className={classes.labelCard}>Amount:</span> */}
                            <span className={classes.labelValue}>
                              ₹{eachToken?.tokenId?.amount}
                            </span>
                          </div>
                          {eachToken?.tokenId?.isPreselect && (
                            <LeadStatusChip
                              label={"Preselect"}
                              style={{
                                color: "#B54708",
                                backgroundColor: "#FFFAEB",
                              }}
                              icon={
                                <Dot width={"0.5rem"} height={"0.5rem"} />
                              }
                            />
                          )}
                          {/* {changeTokenPassData?.eventTokenId?.prerequisiteId ===
                            eachToken?.prerequisiteId && (
                            <div>
                              <Button
                                style={{
                                  color: "#344054",
                                  backgroundColor: "#ffffff",
                                  fontSize: "1.4rem",
                                  lineHeight: "1.8rem",
                                }}
                                btnName={"Update"}
                                clicked={() => {
                                  checkAmountToBePaid();
                                  //console.log()
                                }}
                              />
                            </div>
                          )} */}
                        </div>
                      </Card>
                    );
                  })}
                </div>
              )}
              {showNoTokens && (
                <div className={cssClasses.tokenTable}>
                  <div className={cssClasses.blockLabel} style={{ color: "red", textAlign: "left" }}>
                    No Token available to change
                  </div>
                </div>
              )}
            </>
          )}
          {nextCount === 1 && (
            <>
              <Box padding={"1rem"} textAlign={"left"}>
                <Box>
                  <Box className={cssClasses.headerTitle} mb={2}>
                    Payment Details
                  </Box>

                  {/* <Box className={cssClasses.SubHeader} mb={1}>
                    Payment Record :
                  </Box> */}
                  {/* <CustomRadio
                    value={PaymentType}
                    optionList={PaymentTypeList}
                    onChangeValue={setPaymentType}
                  /> */}

                  {/* {PaymentType === "Partial Payment" && ( */}
                  <div className={cssClasses.wrapperSecondBlock} style={{ gap: "1rem" }}>
                    <div className={cssClasses.blockLabel} >
                      Old Token Amount<span style={{ color: "red" }}> *</span>
                      <div>
                        {/* ₹{numberWithCommas(changeTokenPassData.paidAmount)} */}
                        ₹{numberWithCommas(changeTokenPassData.amount)}
                      </div>

                    </div>
                    <div className={cssClasses.blockLabel} >
                    Paid Old Token Amount  <span style={{ color: "red" }}> *</span>
                      <div>
                        ₹{numberWithCommas(changeTokenPassData.paidAmount)}
                      </div>

                    </div>
                    <div className={cssClasses.blockLabel} >
                      New  Token Amount  <span style={{ color: "red" }}> *</span>
                      <div>
                        ₹{numberWithCommas(changeTokenData?.selectedEventToken?.tokenId?.amount)}
                      </div>

                    </div>
                    
                    {changeTokenPassData.amount - changeTokenData?.selectedEventToken?.tokenId?.amount >= 0 ? "" :
                      <div className={cssClasses.blockLabel}>
                        Difference in  Token Amount  <span style={{ color: "red" }}> *</span>
                        <div>
                          {/* {changeTokenPassData.amount - changeTokenData?.selectedEventToken?.tokenId?.amount >= 0 ? `₹ ${numberWithCommas(changeTokenPassData.amount - changeTokenData?.selectedEventToken?.tokenId?.amount)}` : ` ₹ ${numberWithCommas(changeTokenData?.selectedEventToken?.tokenId?.amount - changeTokenPassData.amount)}`} */}
                          {changeTokenData?.selectedEventToken?.tokenId?.amount - changeTokenPassData.paidAmount < 0 ? `₹ ${numberWithCommas( changeTokenData?.selectedEventToken?.tokenId?.amount - changeTokenPassData.paidAmount)}` : ` ₹ ${numberWithCommas(changeTokenData?.selectedEventToken?.tokenId?.amount - changeTokenPassData.paidAmount)}`}
                        </div>



                      </div>
                    }
                  </div>

                  <Box style={{ display: "flex", flexDirection: "row", marginTop: "2rem" }}>
                    <Box
                      className={cssClasses.subTitle}
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        columnGap: "1rem",
                        alignItems: "center",

                      }}
                    >
                      Amount to be paid :
                    </Box>
                    <Box className={cssClasses.blockLabel} ml={1} >
                      ₹ {numberWithCommas(changeTokenData?.selectedEventToken?.tokenId?.amount - changeTokenPassData.paidAmount > 0 ? changeTokenData?.selectedEventToken?.tokenId?.amount - changeTokenPassData.paidAmount : changeTokenData?.selectedEventToken?.tokenId?.amount - changeTokenPassData.paidAmount === 0 ? 0 : changeTokenData?.selectedEventToken?.tokenId?.amount - changeTokenPassData.paidAmount < 0 ? 0: "")}

                      {/* <CustomInput
                        value={changeTokenPassData.amount - changeTokenData?.selectedEventToken?.tokenId?.amount > 0 ? "00000" : changeTokenPassData.amount - changeTokenData?.selectedEventToken?.tokenId?.amount === 0 ? 0 : changeTokenData?.selectedEventToken?.tokenId?.amount - changeTokenPassData.amount}
                        inputType={"label"}
                        position={"start"}
                        image={"true"}
                        labelText={RupeeIcon}
                        disabled={true}
                      /> */}
                    </Box>
                  </Box>

                  {changeTokenData?.selectedEventToken?.tokenId?.amount - changeTokenPassData.paidAmount < 0 && (
                    <div className={cssClasses.blockLabel} style={{ width: "100%", textAlign: "left", color: "red", marginTop: "1rem" }}>
                      {changeTokenPassData?.tokenName} cannot be changed to {changeTokenData?.selectedEventToken?.tokenId?.name} as old token amount is greater than new token amount.
                    </div>
                  )}
                  {prereqErrMsg !== '' &&
                    <div className={cssClasses.blockLabel} style={{ width: "100%", textAlign: "left", color: "red", marginTop: "1rem" }}>
                    </div>
                  }
                </Box>
              </Box>
            </>
          )}
        </div>
        <div className={cssClasses.wrapperFooter}>
          <div>
            <Button
              style={{
                color: "#344054",
                backgroundColor: "#ffffff",
                fontSize: "1.6rem",
                lineHeight: "2.4rem",
              }}
              btnName={nextCount == 0 ? "Cancel" : "Back"}
              clicked={() => {
                //
                if (nextCount === 0) {
                  closeModal();
                } else {
                  setNextCount(nextCount - 1);
                }
              }}
            />
          </div>
          {/* {nextCount===1&&(  */}
          <div>
            <Button
              style={{
                color: "#ffffff",
                backgroundColor: "#155EEF",
                fontSize: "1.6rem",
                lineHeight: "2.4rem",
              }}
              disable={(EventList.length === 0 && tokenInfo.length === 0)}
              btnName={nextCount !== 1 ? "Next" : changeTokenData.selectedEventToken.tokenId.isPreselect && changeTokenData?.selectedEventToken?.tokenId?.amount - changeTokenPassData.paidAmount >= 0  ? "Alot Unit" : "Confirm"}
              clicked={() => {
                if (nextCount === 0) {
                  checkAllFieldsAreFilled();
                } else {
                  save();
                }
              }}
            />
          </div>
          {/* )} */}
        </div>
      </Box>
    </Modal>
  );
}
